import React from "react";
import {
  defineBlock,
  smartProps,
  useEditor,
  ChildrenBlock,
} from "@smartfire/gutenberg-react";
import { InnerBlocks } from "@wordpress/block-editor";
import style from "./block.module.scss";
import EditableText from "../shared/editable-text";

function Block({ title, image }) {
  const { isEditing } = useEditor();
  return (
    <div className={style.block}>
      <div className={style.content}>
        <EditableText
          tagName="h2"
          className={style.title}
          formattingControls={["bold", "italic"]}
          smartProp="title"
          placeholder={"Entrez un titre"}
        />
        <div className={style.bar} />
        <div className={isEditing ? style.body : style.children}>
          {isEditing ? (
            <InnerBlocks allowedBlocks={["smartfire/press"]} />
          ) : (
            <ChildrenBlock />
          )}
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Espace presse",
  },
});
